import { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import AppointmentDetails from "../../../components/AppointmentDetails/AppointmentDetails";
import useIsMobile from "../../../components/shared/Mobile-Responsive";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile(768);
  
  const handleBack = useCallback(() => {
    navigate("/appointments");
  }, [navigate]);

  const handleClose = useCallback(() => {
    navigate("/appointments");
  }, [navigate]);

  const handleShare = useCallback(() => {
    // TODO: Implement share functionality
    console.log("Share clicked");
  }, []);

  const handleExport = useCallback(() => {
    // TODO: Implement export functionality
    console.log("Export clicked");
  }, []);

  const handleSessionUpdated = useCallback(() => {
    // Refresh appointment data when a session is updated
    console.log("Session updated - refreshing data");
    // TODO: Add logic to refresh appointment data if needed
  }, []);

  // Memoize handler props to prevent unnecessary re-renders
  const appointmentHandlers = useMemo(() => ({
    onBack: handleBack,
    onClose: handleClose,
    onShare: handleShare,
    onExport: handleExport,
    onSessionUpdated: handleSessionUpdated
  }), [handleBack, handleClose, handleShare, handleExport, handleSessionUpdated]);

  if (isMobile) {
    return (
      <>
        <TopBar />
        <div className="bg-white min-h-screen pt-16">
          <AppointmentDetails {...appointmentHandlers} />
        </div>
      </>
    );
  }

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="bg-white min-h-screen rounded-2xl shadow-sm overflow-hidden">
          <div className="w-full bg-white">
            <AppointmentDetails {...appointmentHandlers} />
          </div>
        </div>
      </div>
    </div>
  );
}

// PropTypes validation
Index.propTypes = {};

// Component displayName for debugging
Index.displayName = 'AppointmentDetailPage';